import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export interface QueryData {
    dmsAiUsageStats: GQL.IDmsAiUsageStats;
}

// Admin-only AI processing statistics for the home widget. `companyId` omitted
// aggregates across all companies; passing one narrows to that company and adds the cost per stage.
export const dmsAiUsageStatsQuery: TypedDocumentNode<QueryData> = gql`
    query dmsAiUsageStats($companyId: ID, $days: Int) {
        dmsAiUsageStats(companyId: $companyId, days: $days) {
            from
            to
            companyId
            totals {
                documents
                inputTokens
                cachedInputTokens
                outputTokens
                thoughtsTokens
                costUSD
            }
            days {
                date
                totals {
                    documents
                    inputTokens
                    cachedInputTokens
                    outputTokens
                    thoughtsTokens
                    costUSD
                }
                stages {
                    stage
                    costUSD
                    calls
                }
            }
            stageTotals {
                stage
                costUSD
                calls
            }
            models {
                model
                totals {
                    documents
                    inputTokens
                    cachedInputTokens
                    outputTokens
                    thoughtsTokens
                    costUSD
                }
            }
        }
    }
`;
